import { getFlagEmoji } from '@/methods/flagEmoji'

//  === DocumentTypePage / SaltEdgePage ===

interface Country {
  countryCode: string
  countryName: string
  countryNameEN: string
  countryIcon: string
  types: [
    {
      name: string
      id: number
    },
    {
      name: string
      id: number
    },
  ]
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const mapCountries = (documentTypes: any) =>
  documentTypes.map((country: Country) => ({
    value: country.countryCode,
    label: `${country.countryName} | ${country.countryNameEN}`,
    icon: getFlagEmoji(country.countryCode),
    ...country,
  }))

export const mapCountriesFromSaltedgeArray = (countryList: { name: string; code: string }[]) =>
  countryList
    ? countryList.map((country) => ({
        value: country.code,
        label: country.name,
        icon: getFlagEmoji(country.code),
        countryCode: country.code,
        ...country,
      }))
    : []

// === PlaceOfBirthPage / EIDV Countries ===

export interface EIDV_RawCountry {
  countryName: string
  countryNameEN: string
  countryIcon: string
}

export interface EIDV_Country {
  name: string
  nameEN: string
  value: string
  label: string
  icon: string
  countryCode: string
}

export interface ElectronincIdCountriesResponse {
  [key: string]: EIDV_RawCountry
}

export const mapCountriesArray = (countryList: ElectronincIdCountriesResponse): EIDV_Country[] => {
  if (!countryList) return []

  const alpha2Codes = Object.keys(countryList)

  return Object.values(countryList).map((country, index) => {
    return {
      name: country.countryName,
      nameEN: country.countryNameEN,
      value: `${alpha2Codes[index]}`,
      countryCode: alpha2Codes[index],
      label: `${country.countryName} | ${country.countryNameEN}`,
      icon: getFlagEmoji(alpha2Codes[index]),
    }
  })
}
